import { render, staticRenderFns } from "./NextSameEvents.vue?vue&type=template&id=f171f92c&scoped=true"
import script from "./NextSameEvents.vue?vue&type=script&lang=js"
export * from "./NextSameEvents.vue?vue&type=script&lang=js"
import style0 from "./NextSameEvents.vue?vue&type=style&index=0&id=f171f92c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f171f92c",
  null
  
)

export default component.exports